import React from 'react';
import { Button, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

type Props = {
  color1: string;
  color2: string;
  text: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

interface StyleProps {
  color1: string;
  color2: string;
}

const useStyles = makeStyles<Theme, StyleProps>({
  gradientButton: {
    background: ({ color1, color2 }) =>
      `linear-gradient(135deg, ${color1} 30%, ${color2} 90%)`,
    borderRadius: 16,
    color: 'white',
    padding: '8px 32px',
  },
});

const GradientButton: React.FC<Props> = ({ color1, color2, text, onClick }) => {
  const { gradientButton } = useStyles({ color1, color2 });
  return (
    <Button className={gradientButton} onClick={onClick}>
      {text}
    </Button>
  );
};

export default GradientButton;
